import { forwardRef } from 'react';
import { ThemedButton } from '@Components/MuiWrappers/Button';
import Icon from '@mui/material/Icon';
import useKeyPress from '@Components/Utilities/KeyPress';

const ActionButton = forwardRef((props, ref) => {
    const key = (props.ID || '' + props.className || '');
    useKeyPress('Enter', props.onClick, ref, props.inquiry);

    return (
        props.isDetailPage ?
            <ThemedButton sx={{ width: '100%' }} variant='contained' size='small' key={key} {...props.url ? { href: props.url } : {}} className={'dealer-contact__button ' + props.className || ''} target={props.target || ''} aria-label={props.ariaLabel} onClick={props.onClick ? props.onClick : undefined} {...(ref?.current ? { ref: (element) => ref.current[props.inquiry] = element } : {})}>
                <Icon className={`dealer-contact__icon ${props.iconClass}`} />
                <span className={props.buttonClass || ''}>
                    {props.buttonText || ''}
                </span>
            </ThemedButton>
            :
            <a {...props.url ? {} : { tabIndex: "0", role: "button" }} key={key} {...props.url ? { href: props.url } : {}} data-phonetype={props.phoneType || ''} className={props.className || ''} target={props.target || ''} onClick={props.onClick ? props.onClick : undefined} {...(ref?.current ? { ref: (element) => ref.current[props.inquiry] = element } : {})} aria-label={props.ariaLabel}>
                {props.imageUrl ? <img src={props.imageUrl} alt={props.imageAlt} width={props.imageWidth} height={props.imageHeight} /> : <i className={props.iconClass || ''} aria-hidden={props.iconAriaHidden}>{props.iconText || ''}</i>}
                <span className={props.buttonClass || ''}>{props.buttonText || ''}</span>
                {props.includeRightChevron && <i className='fas fa-chevron-right' aria-hidden='true' />}
            </a>
    );
});

export default ActionButton;